/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_TagsInputs */

const id_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag (dipisahkan koma)`)
};

const ms_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag (dipisahkan koma)`)
};

const da_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (komma-separeret)`)
};

const de_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (durch Komma getrennt)`)
};

const en_us2_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const es_es2_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas (separadas por comas)`)
};

const es_mx2_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas (separadas por comas)`)
};

const fil_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Tag (pinaghihiwalay ng kuwit)`)
};

const fr_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (séparés par des virgules)`)
};

const it_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag (separati da virgole)`)
};

const hu_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Címkék (vesszővel elválasztva)`)
};

const nl_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (komma-gescheiden)`)
};

const no_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagger (kommaseparert)`)
};

const pl_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagi (oddzielone przecinkami)`)
};

const pt_br2_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const pt_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas (separadas por vírgulas)`)
};

const ro_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichete (separate prin virgulă)`)
};

const fi_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagit (pilkuilla eroteltuna)`)
};

const sv_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taggar (komma-separerade)`)
};

const vi_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ (phân cách bằng dấu phẩy)`)
};

const tr_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiketler (virgülle ayrılmış)`)
};

const cs_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Štítky (oddělené čárkou)`)
};

const bg_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Етикети (разделени със запетая)`)
};

const ru_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги (через запятую)`)
};

const uk_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги (через кому)`)
};

const ar_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوسوم (مفصولة بفواصل)`)
};

const hi_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग (अल्पविराम से अलग)`)
};

const th_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แท็ก (คั่นด้วยเครื่องหมายจุลภาค)`)
};

const ja_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ（カンマ区切り）`)
};

const zh_cn2_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const zh_hant1_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const ko_forms_review_tags = /** @type {(inputs: Forms_Review_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

/**
* | output |
* | --- |
* | "Tags (comma-separated)" |
*
* @param {Forms_Review_TagsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_tags = /** @type {((inputs?: Forms_Review_TagsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_TagsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_tags(inputs)
	if (locale === "ms") return ms_forms_review_tags(inputs)
	if (locale === "da") return da_forms_review_tags(inputs)
	if (locale === "de") return de_forms_review_tags(inputs)
	if (locale === "en-US") return en_us2_forms_review_tags(inputs)
	if (locale === "es-ES") return es_es2_forms_review_tags(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_tags(inputs)
	if (locale === "fil") return fil_forms_review_tags(inputs)
	if (locale === "fr") return fr_forms_review_tags(inputs)
	if (locale === "it") return it_forms_review_tags(inputs)
	if (locale === "hu") return hu_forms_review_tags(inputs)
	if (locale === "nl") return nl_forms_review_tags(inputs)
	if (locale === "no") return no_forms_review_tags(inputs)
	if (locale === "pl") return pl_forms_review_tags(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_tags(inputs)
	if (locale === "pt") return pt_forms_review_tags(inputs)
	if (locale === "ro") return ro_forms_review_tags(inputs)
	if (locale === "fi") return fi_forms_review_tags(inputs)
	if (locale === "sv") return sv_forms_review_tags(inputs)
	if (locale === "vi") return vi_forms_review_tags(inputs)
	if (locale === "tr") return tr_forms_review_tags(inputs)
	if (locale === "cs") return cs_forms_review_tags(inputs)
	if (locale === "bg") return bg_forms_review_tags(inputs)
	if (locale === "ru") return ru_forms_review_tags(inputs)
	if (locale === "uk") return uk_forms_review_tags(inputs)
	if (locale === "ar") return ar_forms_review_tags(inputs)
	if (locale === "hi") return hi_forms_review_tags(inputs)
	if (locale === "th") return th_forms_review_tags(inputs)
	if (locale === "ja") return ja_forms_review_tags(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_tags(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_tags(inputs)
	return ko_forms_review_tags(inputs)
});
export { forms_review_tags as "forms.review.tags" }